import React, {useState} from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Image, { IImage } from 'tbk-components/src/components/Image';
import { ILink } from 'tbk-components/src/components/Button';

export interface IRegionMissionCalloutItem {
	image?: IImage;
	donationCode?: string;
	mission?: string;
	regionText?: string;
	calloutHeading?: string;
	calloutText?: string;
	calloutLink?: ILink;
}

export interface IRegionAccordionItem {
	title?: string;
	missionTitle?: string;
	missionInfoHeading?: string;
	missionHeadingItems?: string[];
	calloutsHeading?: string;
	calloutItems?: IRegionMissionCalloutItem[];
}

export interface IRegionAccordionProps extends IBaseElementProps {
	id?: string;
	heading?: string;
	description?: string;
	missionInstructions?: string;
	items?: IRegionAccordionItem[];
}

const RegionAccordion: React.FC<IRegionAccordionProps> = ({
	className,
	classNames = [],
	id,
	heading,
	description,
	missionInstructions,
	items,
}) => {
	const [filteredMissions,setFilteredMissions] = useState({} );

	const adjustFilteredMissions = ( filteredMission, currentValue ) => {
		if (!currentValue) {
			let copyOfFilteredMissions = {...filteredMissions}
			delete copyOfFilteredMissions[ filteredMission ];
			setFilteredMissions(filteredMissions => ({
				...copyOfFilteredMissions
			}));
		} else {
			let newMission = {[filteredMission]:currentValue}
			setFilteredMissions(filteredMissions => ({
				...filteredMissions,
				...newMission
			}));
		}
	};

	return (
		<div
			className={
				className || cn('region-accordion accordion', ...classNames)
			}
			id={id}
		>
			<div className="region-accordion__intro-content">
				{heading && (
					<h2 className="region-accordion__intro-heading" dangerouslySetInnerHTML={ {__html: heading}}></h2>
				)}
				{description && (
					<p className="region-accordion__intro-description" dangerouslySetInnerHTML={ {__html: description}}></p>
				)}
			</div>
			{(items || []).map((item, index) => (
				<div className="accordion__item" key={index}>
					<button
						type="button"
						className="accordion__item-title collapsed"
						data-bs-toggle="collapse"
						data-bs-target={'#region-accordion-collapse-' + index}
						aria-expanded="false"
						aria-controls={'region-accordion-collapse-' + index}
						dangerouslySetInnerHTML={ {__html: item.title}}
					></button>
					<div
						id={'region-accordion-collapse-' + index}
						className="accordion__item-content collapse"
						data-bs-parent={'#' + id}
					>
						<div className="accordion__item-content__inner">
							<div className="region-accordion-item__text-content container-fluid">
								<div className="row">
									<div>
										{missionInstructions && (
											<p className="region-accordion-item__description" dangerouslySetInnerHTML={ {__html: missionInstructions}}></p>
										)}
									</div>
									<div>
										{item.missionInfoHeading && (
											<p className="region-accordion-item__mission-info-heading" dangerouslySetInnerHTML={ {__html: item.missionInfoHeading}}></p>
										)}
										{item.missionHeadingItems &&
											item.missionHeadingItems.map(
												(missionItem, missionIndex) => (
													<p
														key={missionIndex}
														className="region-accordion-item__mission-heading-item"
													>
														<button
															className={`region-accordion-item__mission-heading-link btn ${
																filteredMissions[item.missionTitle] === missionItem ? 'active' : ''
															}`}
															onClick={(e) =>
																adjustFilteredMissions( item.missionTitle, missionItem )
															}
														>{missionItem}</button>
													</p>
												),
											)}
									</div>
								</div>
							</div>

							<div className="region-accordion-item__callouts container-fluid">
								{filteredMissions[item.missionTitle] &&
									<div className="row">
										<div className="col-12">
											{item.calloutsHeading && (
												<h4 className="region-accordion-item__callouts-heading"
													dangerouslySetInnerHTML={{__html: item.calloutsHeading}}></h4>
											)}
										</div>
									</div>
								}
								<div className="row">
									{item.calloutItems &&
										item.calloutItems.map((item, index) => (
											<>
											{ filteredMissions[item.regionText] && filteredMissions[item.regionText] == item.mission && (
											<div
												key={index}
												className="region-accordion-item__callout col-12 col-md-6 col-lg-4"
											>
												{item.calloutLink && (
													<a
														href={
															item.calloutLink
																.href
														}
													>
														{item.image && (
															<div className="region-accordion-item__callout-image">
																<Image
																	className="img-fluid"
																	{...item.image}
																/>
															</div>
														)}
														{item.donationCode && (
															<p className="region-accordion-item__callout-donation-code">
																<span>
																	{
																		item.donationCode
																	}
																</span>
																{item.regionText && (
																	<>
																		<span>
																			•
																		</span>
																		<span dangerouslySetInnerHTML={ {__html: item.regionText}}></span>
																	</>
																)}
															</p>
														)}
														{item.calloutHeading && (
															<p className="region-accordion-item__callout-heading" dangerouslySetInnerHTML={ {__html: item.calloutHeading}}></p>
														)}
														{item.calloutText && (
															<p
																className="region-accordion-item__callout-text"
																dangerouslySetInnerHTML={{
																	__html: item.calloutText,
																}}
															></p>
														)}
														{item.calloutLink && (
															<button className="region-accordion-item__callout-btn btn btn-sm btn-primary">
																{
																	item
																		.calloutLink
																		.label
																}
															</button>
														)}
													</a>
												)}
											</div>
											)}
											</>
										))}
								</div>
							</div>
						</div>
					</div>
				</div>
			))}
		</div>
	);
};

export default RegionAccordion;
